<template>
  <!-- 客户列表 -->
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <!-- content -->
    <el-tabs v-model="activeName" @tab-click="handleClick" class="top_nav">
      <!-- 资产负债表 -->
      <el-tab-pane label="资产负债表" name="1">
        <div class="big_box4">
          <div class="top_title3">
            <h5>资产负债表</h5>

            <!-- <div class="bottom_font clearfix">
              <h6 class="left">纳税人名称：<span>{{comName}}</span></h6>
              <h6 class="center"><span>{{durationOfTaxTime}}</span></h6>
              <h6 class="right">
                <p>单位：元</p>
                <p>纳税人识别号：<span>{{taxNo}}</span></p>
              </h6>
            </div> -->
          </div>
          <!-- <table class="content" cellspacing="0" width="100%" height="150">
            <caption>xxxx</caption> 
            <tr v-for="(item,index) in list" :key="index">
              <td v-if="item2.type != '0'" v-for="(item2,index2) in item" :key="index2" :rowspan=item2.rowspan :colspan=item2.colspan>{{item2.value}}</td>
            </tr>
          </table> -->
          <table class="content" cellspacing="0" width="100%" >
            <tr class="top_bg">
              <td class="center" style="width:21%;">资产</td>
              <td class="center" style="width:4%;">行次</td>
              <td class="center" style="width:12%;">期末余额</td>
              <td class="center" style="width:12%;">年初余额</td>
              <td class="center" style="width:21%;">负债及所有者权益</td>
              <td class="center" style="width:4%;">行次</td>
              <td class="center" style="width:12%;">期末余额</td>
              <td class="center" style="width:12%;">年初余额</td>
            </tr>
          </table>
          <div class="fixed_box_table" :style="{height:contentStyleObj}">
            <table class="content" cellspacing="0">
              <tr>
                <td style="width:21%;">流动资产：</td>
                <td style="width:4%;" class="center"></td>
                <!-- <td><input type="text" v-model="list[0].qmyeZc"></td> -->
                <td style="width:12%;"><span></span></td>
                <td style="width:12%;"><span></span></td>
                <!-- <td><input type="text" v-model="list[0].ncyeZc"></td> -->
                <td style="width:21%;">流动负债：</td>
                <td style="width:4%;" class="center"></td>
                <td style="width:12%;"><span></span></td>
                <td style="width:12%;"><span></span></td>
                <!-- <td><input type="text" v-model="list[0].qmyeQy"></td> -->
                <!-- <td><input type="text" v-model="list[0].ncyeQy"></td> -->
              </tr>

              <tr>
                <td class="left_k">货币资金</td>
                <td class="center">1</td>
                <td><input type="text" v-model="list[0].qmyeZc"></td>
                <td><input type="text" v-model="list[0].ncyeZc"></td>
                <td class="left_k">短期借款</td>
                <td class="center">31</td>
                <td><input type="text" v-model="list[0].qmyeQy"></td>
                <td><input type="text" v-model="list[0].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">短期投资</td>
                <td class="center">2</td>
                <td><input type="text" v-model="list[1].qmyeZc"></td>
                <td><input type="text" v-model="list[1].ncyeZc"></td>
                <td class="left_k">应付票据</td>
                <td class="center">32</td>
                <td><input type="text" v-model="list[1].qmyeQy"></td>
                <td><input type="text" v-model="list[1].ncyeQy"></td>
              </tr>
              <tr>
                <td class="left_k">应收票据</td>
                <td class="center">3</td>
                <td><input type="text" v-model="list[2].qmyeZc"></td>
                <td><input type="text" v-model="list[2].ncyeZc"></td>
                <td class="left_k">应付账款</td>
                <td class="center">33</td>
                <td><input type="text" v-model="list[2].qmyeQy"></td>
                <td><input type="text" v-model="list[2].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">应收账款</td>
                <td class="center">4</td>
                <td><input type="text" v-model="list[3].qmyeZc"></td>
                <td><input type="text" v-model="list[3].ncyeZc"></td>
                <td class="left_k">预收账款</td>
                <td class="center">34</td>
                <td><input type="text" v-model="list[3].qmyeQy"></td>
                <td><input type="text" v-model="list[3].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">预付账款</td>
                <td class="center">5</td>
                <td><input type="text" v-model="list[4].qmyeZc"></td>
                <td><input type="text" v-model="list[4].ncyeZc"></td>
                <td class="left_k">应付职工薪酬</td>
                <td class="center">35</td>
                <td><input type="text" v-model="list[4].qmyeQy"></td>
                <td><input type="text" v-model="list[4].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">应收股利</td>
                <td class="center">6</td>
                <td><input type="text" v-model="list[5].qmyeZc"></td>
                <td><input type="text" v-model="list[5].ncyeZc"></td>
                <td class="left_k">应交税费</td>
                <td class="center">36</td>
                <td><input type="text" v-model="list[5].qmyeQy"></td>
                <td><input type="text" v-model="list[5].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">应收利息</td>
                <td class="center">7</td>
                <td><input type="text" v-model="list[6].qmyeZc"></td>
                <td><input type="text" v-model="list[6].ncyeZc"></td>
                <td class="left_k">应付利息</td>
                <td class="center">37</td>
                <td><input type="text" v-model="list[6].qmyeQy"></td>
                <td><input type="text" v-model="list[6].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">其他应收款</td>
                <td class="center">8</td>
                <td><input type="text" v-model="list[7].qmyeZc"></td>
                <td><input type="text" v-model="list[7].ncyeZc"></td>
                <td class="left_k">应付利润</td>
                <td class="center">38</td>
                <td><input type="text" v-model="list[7].qmyeQy"></td>
                <td><input type="text" v-model="list[7].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">存货</td>
                <td class="center">9</td>
                <td><input type="text" v-model="list[8].qmyeZc"></td>
                <td><input type="text" v-model="list[8].ncyeZc"></td>
                <td class="left_k">其他应付款</td>
                <td class="center">39</td>
                <td><input type="text" v-model="list[8].qmyeQy"></td>
                <td><input type="text" v-model="list[8].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">其中：原材料</td>
                <td class="center">10</td>
                <td><input type="text" v-model="list[9].qmyeZc"></td>
                <td><input type="text" v-model="list[9].ncyeZc"></td>
                <td class="left_k">其他流动负债</td>
                <td class="center">40</td>
                <td><input type="text" v-model="list[9].qmyeQy"></td>
                <td><input type="text" v-model="list[9].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">在产品</td>
                <td class="center">11</td>
                <td><input type="text" v-model="list[10].qmyeZc"></td>
                <td><input type="text" v-model="list[10].ncyeZc"></td>
                <td class="center weight">流动负债合计</td>
                <td class="center">41</td>
                <td><input type="text" v-model="list[10].qmyeQy"></td>
                <td><input type="text" v-model="list[10].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">库存商品</td>
                <td class="center">12</td>
                <td><input type="text" v-model="list[11].qmyeZc"></td>
                <td><input type="text" v-model="list[11].ncyeZc"></td>
                <td>非流动负债：</td>
                <td class="center"></td>
                <td><span></span></td>
                <td><span></span></td>
              </tr>

              <tr>
                <td class="left_k">周转材料</td>
                <td class="center">13</td>
                <td><input type="text" v-model="list[12].qmyeZc"></td>
                <td><input type="text" v-model="list[12].ncyeZc"></td>
                <td class="left_k">长期借款</td>
                <td class="center">42</td>
                <td><input type="text" v-model="list[12].qmyeQy"></td>
                <td><input type="text" v-model="list[12].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">其他流动资产</td>
                <td class="center">14</td>
                <td><input type="text" v-model="list[13].qmyeZc"></td>
                <td><input type="text" v-model="list[13].ncyeZc"></td>
                <td class="left_k">长期应付款</td>
                <td class="center">43</td>
                <td><input type="text" v-model="list[13].qmyeQy"></td>
                <td><input type="text" v-model="list[13].ncyeQy"></td>
              </tr>

              <tr>
                <td class="center weight">流动资产合计</td>
                <td class="center">15</td>
                <td><input type="text" v-model="list[14].qmyeZc"></td>
                <td><input type="text" v-model="list[14].ncyeZc"></td>
                <td class="left_k">递延收益</td>
                <td class="center">44</td>
                <td><input type="text" v-model="list[14].qmyeQy"></td>
                <td><input type="text" v-model="list[14].ncyeQy"></td>
              </tr>

              <tr>
                <td>非流动资产：</td>
                <td class="center"></td>
                <td><span></span></td>
                <td><span></span></td>
                <td class="left_k">其他非流动负债</td>
                <td class="center">45</td>
                <td><input type="text" v-model="list[15].qmyeQy"></td>
                <td><input type="text" v-model="list[15].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">长期债券投资</td>
                <td class="center">16</td>
                <td><input type="text" v-model="list[16].qmyeZc"></td>
                <td><input type="text" v-model="list[16].ncyeZc"></td>
                <td class="left_k">非流动负债合计</td>
                <td class="center">46</td>
                <td><input type="text" v-model="list[16].qmyeQy"></td>
                <td><input type="text" v-model="list[16].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">长期股权投资</td>
                <td class="center">17</td>
                <td><input type="text" v-model="list[17].qmyeZc"></td>
                <td><input type="text" v-model="list[17].ncyeZc"></td>
                <td class="left_k">负债合计</td>
                <td class="center">47</td>
                <td><input type="text" v-model="list[17].qmyeQy"></td>
                <td><input type="text" v-model="list[17].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">固定资产原价</td>
                <td class="center">18</td>
                <td><input type="text" v-model="list[18].qmyeZc"></td>
                <td><input type="text" v-model="list[18].ncyeZc"></td>
                <td class="left_k"></td>
                <td class="center"></td>
                <td><span></span></td>
                <td><span></span></td>
              </tr>

              <tr>
                <td class="left_k">减：累计折旧</td>
                <td class="center">19</td>
                <td><input type="text" v-model="list[19].qmyeZc"></td>
                <td><input type="text" v-model="list[19].ncyeZc"></td>
                <td class="left_k"></td>
                <td class="center"></td>
                <td><span></span></td>
                <td><span></span></td>
              </tr>

              <tr>
                <td class="left_k">固定资产账面价值</td>
                <td class="center">20</td>
                <td><input type="text" v-model="list[20].qmyeZc"></td>
                <td><input type="text" v-model="list[20].ncyeZc"></td>
                <td class="left_k"></td>
                <td class="center"></td>
                <td><span></span></td>
                <td><span></span></td>
              </tr>

              <tr>
                <td class="left_k">在建工程</td>
                <td class="center">21</td>
                <td><input type="text" v-model="list[21].qmyeZc"></td>
                <td><input type="text" v-model="list[21].ncyeZc"></td>
                <td class="left_k"></td>
                <td class="center"></td>
                <td><span></span></td>
                <td><span></span></td>
              </tr>

              <tr>
                <td class="left_k">工程物资</td>
                <td class="center">22</td>
                <td><input type="text" v-model="list[22].qmyeZc"></td>
                <td><input type="text" v-model="list[22].ncyeZc"></td>
                <td class="left_k"></td>
                <td class="center"></td>
                <td><span></span></td>
                <td><span></span></td>
              </tr>

              <tr>
                <td class="left_k">固定资产清理</td>
                <td class="center">23</td>
                <td><input type="text" v-model="list[23].qmyeZc"></td>
                <td><input type="text" v-model="list[23].ncyeZc"></td>
                <td class="left_k"></td>
                <td class="center"></td>
                <td><span></span></td>
                <td><span></span></td>
              </tr>

              <tr>
                <td class="left_k">生产性生物资产</td>
                <td class="center">24</td>
                <td><input type="text" v-model="list[24].qmyeZc"></td>
                <td><input type="text" v-model="list[24].ncyeZc"></td>
                <td>所有者权益：</td>
                <td class="center"></td>
                <td><span></span></td>
                <td><span></span></td>
              </tr>

              <tr>
                <td class="left_k">无形资产</td>
                <td class="center">25</td>
                <td><input type="text" v-model="list[25].qmyeZc"></td>
                <td><input type="text" v-model="list[25].ncyeZc"></td>
                <td class="left_k">实收资本（或股本）</td>
                <td class="center">48</td>
                <td><input type="text" v-model="list[25].qmyeQy"></td>
                <td><input type="text" v-model="list[25].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">开发支出</td>
                <td class="center">26</td>
                <td><input type="text" v-model="list[26].qmyeZc"></td>
                <td><input type="text" v-model="list[26].ncyeZc"></td>
                <td class="left_k">资本公积</td>
                <td class="center">49</td>
                <td><input type="text" v-model="list[26].qmyeQy"></td>
                <td><input type="text" v-model="list[26].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">长期待摊费用</td>
                <td class="center">27</td>
                <td><input type="text" v-model="list[27].qmyeZc"></td>
                <td><input type="text" v-model="list[27].ncyeZc"></td>
                <td class="left_k">盈余公积</td>
                <td class="center">50</td>
                <td><input type="text" v-model="list[27].qmyeQy"></td>
                <td><input type="text" v-model="list[27].ncyeQy"></td>
              </tr>

              <tr>
                <td class="left_k">其他非流动资产</td>
                <td class="center">28</td>
                <td><input type="text" v-model="list[28].qmyeZc"></td>
                <td><input type="text" v-model="list[28].ncyeZc"></td>
                <td class="left_k">未分配利润</td>
                <td class="center">51</td>
                <td><input type="text" v-model="list[28].qmyeQy"></td>
                <td><input type="text" v-model="list[28].ncyeQy"></td>
              </tr>

              <tr>
                <td class="center weight">非流动资产合计</td>
                <td class="center">29</td>
                <td><input type="text" v-model="list[29].qmyeZc"></td>
                <td><input type="text" v-model="list[29].ncyeZc"></td>
                <td class="center weight">所有者权益合计</td>
                <td class="center">52</td>
                <td><input type="text" v-model="list[29].qmyeQy"></td>
                <td><input type="text" v-model="list[29].ncyeQy"></td>
              </tr>

              <tr>
                <td class="center weight">资产合计</td>
                <td class="center">30</td>
                <td><input type="text" v-model="list[30].qmyeZc"></td>
                <td><input type="text" v-model="list[30].ncyeZc"></td>
                <td class="center weight">负债和所有者权益合计</td>
                <td class="center">53</td>
                <td><input type="text" v-model="list[30].qmyeQy"></td>
                <td><input type="text" v-model="list[30].ncyeQy"></td>
              </tr>
            </table>
          </div>

        </div>
        <div class="save_box">
          <el-button  @click="saveZcfz" type="primary" size="small" plain>保存</el-button>
        </div>
      </el-tab-pane>
      <!-- 资产负债表 end -->
      <!-- 利润表 -->
      <el-tab-pane label="利润表(年报)" name="2">
        <div class="big_box4">
          <div class="top_title3">
            <h5>利润表(年报)</h5>
            <!-- <div style="font-size:12px;color:red;margin-bottom: 10px;">
              （上年金额）
            </div> -->
            <!-- <div class="bottom_font clearfix">
              <h6 class="left">纳税人名称：<span>{{comName}}</span></h6>
              <h6 class="center"><span>{{periodLrb}}</span></h6>
              <h6 class="right">
                <p>单位：元</p>
                <p>纳税人识别号：<span>{{taxNo}}</span></p>
              </h6>
            </div> -->
          </div>
          <table class="content" cellspacing="0" width="100%" >
            <tr class="top_bg">
              <td class="center" style="width:46%;">项目</td>
              <td class="center" style="width:4%;">行次</td>
              <td class="center" style="width:25%;">本年累计金额</td>
              <td class="center" style="width:25%;">上年金额</td>
            </tr>
          </table>
          <div class="fixed_box_table" :style="{height:contentStyleObj}">
            <table class="content" cellspacing="0">
              <tr>
                <td class="weight center" style="width:46%;">一、营业收入</td>
                <td class="center" style="width:4%;">1</td>
                <td style="width:25%;"><input type="text" v-model="attachArr[0].yearTotal"></td>
                <!-- <td class="top_bg" style="width:25%;"><input type="text" v-model="attachArr[0].lastYearTotal"></td> -->
                <td class="top_bg" style="width:25%;"></td>

              </tr>
              <tr>
                <td>减：营业成本</td>
                <td class="center">2</td>
                <td><input type="text" v-model="attachArr[1].yearTotal"></td>
                <!-- <td><input type="text" v-model="attachArr[1].lastYearTotal"></td> -->
                <td class="top_bg"></td>

              </tr>
              <tr>
                <td>税金及附加</td>
                <td class="center">3</td>
                <td><input type="text" v-model="attachArr[2].yearTotal"></td>
                <!-- <td><input type="text" v-model="attachArr[2].lastYearTotal"></td> -->
                <td class="top_bg"></td>

              </tr>
              <tr>
                <td>其中：消费税</td>
                <td class="center">4</td>
                <td><input type="text" v-model="attachArr[3].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[3].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>营业税</td>
                <td class="center">5</td>
                <td><input type="text" v-model="attachArr[4].yearTotal"></td>
                <td class="top_bg"></td>
                
                <!-- <td><input type="text" v-model="attachArr[4].lastYearTotal"></td> -->
              </tr>

              <tr>
                <td>城市维护建设税</td>
                <td class="center">6</td>
                <td><input type="text" v-model="attachArr[5].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[5].lastYearTotal"></td> -->
              </tr>

              <tr>
                <td>资源税</td>
                <td class="center">7</td>
                <td><input type="text" v-model="attachArr[6].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[6].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>土地增值税</td>
                <td class="center">8</td>
                <td><input type="text" v-model="attachArr[7].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[7].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>城镇土地使用税、房产税、车船税、印花税</td>
                <td class="center">9</td>
                <td><input type="text" v-model="attachArr[8].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[8].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>教育附加、矿产资源、排污费</td>
                <td class="center">10</td>
                <td><input type="text" v-model="attachArr[9].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[9].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>销售费用</td>
                <td class="center">11</td>
                <td><input type="text" v-model="attachArr[10].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[10].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>其中：商品维修费</td>
                <td class="center">12</td>
                <td><input type="text" v-model="attachArr[11].yearTotal"></td>
                <td class="top_bg"></td>
                
                <!-- <td><input type="text" v-model="attachArr[11].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>广告费和业务宣传费</td>
                <td class="center">13</td>
                <td><input type="text" v-model="attachArr[12].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[12].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>管理费用</td>
                <td class="center">14</td>
                <td><input type="text" v-model="attachArr[13].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[13].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>其中：开办费</td>
                <td class="center">15</td>
                <td><input type="text" v-model="attachArr[14].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[14].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>业务招待费</td>
                <td class="center">16</td>
                <td><input type="text" v-model="attachArr[15].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[15].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>研究费用</td>
                <td class="center">17</td>
                <td><input type="text" v-model="attachArr[16].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[16].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>财务费用</td>
                <td class="center">18</td>
                <td><input type="text" v-model="attachArr[17].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[17].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>其中：利息费用(收入以-号填列)</td>
                <td class="center">19</td>
                <td><input type="text" v-model="attachArr[18].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[18].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>加：投资收益</td>
                <td class="center">20</td>
                <td><input type="text" v-model="attachArr[19].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[19].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td class="weight center">二、营业利润</td>
                <td class="center">21</td>
                <td><input type="text" v-model="attachArr[20].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[20].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>加：营业外收入</td>
                <td class="center">22</td>
                <td><input type="text" v-model="attachArr[21].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[21].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>其中：政府补助</td>
                <td class="center">23</td>
                <td><input type="text" v-model="attachArr[22].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[22].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>减：营业外支出</td>
                <td class="center">24</td>
                <td><input type="text" v-model="attachArr[23].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[23].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>其中：坏账损失</td>
                <td class="center">25</td>
                <td><input type="text" v-model="attachArr[24].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[24].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>无法收回的长期债券投资损失</td>
                <td class="center">26</td>
                <td><input type="text" v-model="attachArr[25].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[25].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>无法收回的长期股权投资损失</td>
                <td class="center">27</td>
                <td><input type="text" v-model="attachArr[26].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[26].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>自然灾害等不可抗力因素造成的损失</td>
                <td class="center">28</td>
                <td><input type="text" v-model="attachArr[27].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[27].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>税收滞纳金</td>
                <td class="center">29</td>
                <td><input type="text" v-model="attachArr[28].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[28].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td class="weight center">三、利润总额</td>
                <td class="center">30</td>
                <td><input type="text" v-model="attachArr[29].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[29].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td>减：所得税费用</td>
                <td class="center">31</td>
                <td><input type="text" v-model="attachArr[30].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[30].lastYearTotal"></td> -->
              </tr>
              <tr>
                <td class="weight center">四、净利润</td>
                <td class="center">32</td>
                <td><input type="text" v-model="attachArr[31].yearTotal"></td>
                <td class="top_bg"></td>

                <!-- <td><input type="text" v-model="attachArr[31].lastYearTotal"></td> -->
              </tr>
            </table>
          </div>
        </div>
        <div class="save_box">
          <el-button @click="saveLrb" type="primary" size="mini" plain>保存</el-button>
        </div>
      </el-tab-pane>
      <!-- 利润表 end -->

      <!-- 现金流量表 -->
      <el-tab-pane label="现金流量表" name="4">
        <div class="big_box4">
          <div class="top_title3">
            <h5>现金流量表</h5>
            <div class="bottom_font clearfix">
              <h6 class="left">纳税人名称：<span>{{comName}}</span></h6>
              <h6 class="center"><span>{{periodLrb2}}</span></h6>
              <h6 class="right">
                <p>单位：元</p>
                <p>纳税人识别号：<span>{{taxNo}}</span></p>
              </h6>
            </div>
          </div>
          <table class="content" cellspacing="0" width="100%" >
            <tr class="top_bg">
              <td class="center" style="width:46%;">项目</td>
              <td class="center" style="width:4%;">行次</td>
              <td class="center" style="width:25%;">本年累计金额</td>
              <td class="center" style="width:25%;">本月金额</td>
            </tr>
          </table>
          <div class="fixed_box_table" :style="{height:contentStyleObj}">
            <table class="content" cellspacing="0">
              <tr>
                <td class="weight center" style="width:46%;">一、经营活动产生的现金流量：</td>
                <td class="center" style="width:4%;"></td>
                <td style="width:25%;"></td>
                <td style="width:25%;"></td>
              </tr>
              <tr>
                <td>销售产成品、商品、提供劳务收到的现金</td>
                <td class="center">1</td>
                <td><input type="text" v-model="xjllbList[0].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[0].lastYearTotal"></td>
              </tr>
              <tr>
                <td>收到其他与经营活动有关的现金</td>
                <td class="center">2</td>
                <td><input type="text" v-model="xjllbList[1].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[1].lastYearTotal"></td>
              </tr>
              <tr>
                <td>购买原材料、商品、接受劳务支付的现金</td>
                <td class="center">3</td>
                <td><input type="text" v-model="xjllbList[2].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[2].lastYearTotal"></td>
              </tr>
              <tr>
                <td>支付的职工薪酬</td>
                <td class="center">4</td>
                <td><input type="text" v-model="xjllbList[3].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[3].lastYearTotal"></td>
              </tr>

              <tr>
                <td>支付的税费</td>
                <td class="center">5</td>
                <td><input type="text" v-model="xjllbList[4].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[4].lastYearTotal"></td>
              </tr>

              <tr>
                <td>支付其他与经营活动有关的现金</td>
                <td class="center">6</td>
                <td><input type="text" v-model="xjllbList[5].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[5].lastYearTotal"></td>
              </tr>
              <tr>
                <td>经营活动产生的现金流量净额</td>
                <td class="center">7</td>
                <td><input type="text" v-model="xjllbList[6].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[6].lastYearTotal"></td>
              </tr>


              <tr>
                <td class="weight center">二、投资活动产生的现金流量：</td>
                <td class="center"></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>收回短期投资、长期债券投资和长期股权投资收到的现金</td>
                <td class="center">8</td>
                <td><input type="text" v-model="xjllbList[7].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[7].lastYearTotal"></td>
              </tr>
              <tr>
                <td>取得投资收益收到的现金</td>
                <td class="center">9</td>
                <td><input type="text" v-model="xjllbList[8].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[8].lastYearTotal"></td>
              </tr>
              <tr>
                <td>处置固定资产、无形资产和其他非流动资产收回的现金净额</td>
                <td class="center">10</td>
                <td><input type="text" v-model="xjllbList[9].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[9].lastYearTotal"></td>
              </tr>
              <tr>
                <td>短期投资、长期债券投资和长期股权投资支付的现金</td>
                <td class="center">11</td>
                <td><input type="text" v-model="xjllbList[10].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[10].lastYearTotal"></td>
              </tr>

              <tr>
                <td>购建固定资产、无形资产和其他非流动资产支付的现金</td>
                <td class="center">12</td>
                <td><input type="text" v-model="xjllbList[11].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[11].lastYearTotal"></td>
              </tr>

              <tr>
                <td>投资活动产生的现金流量净额</td>
                <td class="center">13</td>
                <td><input type="text" v-model="xjllbList[12].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[12].lastYearTotal"></td>
              </tr>


              <tr>
                <td class="weight center">三、筹资活动产生的现金流量：</td>
                <td class="center"></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>取得借款收到的现金</td>
                <td class="center">14</td>
                <td><input type="text" v-model="xjllbList[13].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[13].lastYearTotal"></td>
              </tr>
              <tr>
                <td>吸收投资者投资收到的现金</td>
                <td class="center">15</td>
                <td><input type="text" v-model="xjllbList[14].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[14].lastYearTotal"></td>
              </tr>
              <tr>
                <td>偿还借款本金支付的现金</td>
                <td class="center">16</td>
                <td><input type="text" v-model="xjllbList[15].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[15].lastYearTotal"></td>
              </tr>
              <tr>
                <td>偿还借款利息支付的现金</td>
                <td class="center">17</td>
                <td><input type="text" v-model="xjllbList[16].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[16].lastYearTotal"></td>
              </tr>

              <tr>
                <td>分配利润支付的现金</td>
                <td class="center">18</td>
                <td><input type="text" v-model="xjllbList[17].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[17].lastYearTotal"></td>
              </tr>

              <tr>
                <td>筹资活动产生的现金流量净额</td>
                <td class="center">19</td>
                <td><input type="text" v-model="xjllbList[18].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[18].lastYearTotal"></td>
              </tr>

              <tr>
                <td class="weight center">四、现金净增加额</td>
                <td class="center">20</td>
                <td><input type="text" v-model="xjllbList[19].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[19].lastYearTotal"></td>
              </tr>
              <tr>
                <td>加：期初现金余额</td>
                <td class="center">21</td>
                <td><input type="text" v-model="xjllbList[20].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[20].lastYearTotal"></td>
              </tr>
              <tr>
                <td class="weight center">五、期末现金余额</td>
                <td class="center">22</td>
                <td><input type="text" v-model="xjllbList[21].yearTotal"></td>
                <td><input type="text" v-model="xjllbList[21].lastYearTotal"></td>
              </tr>
            
            </table>
          </div>
        </div>

        <div class="save_box">
          <el-button @click="saveXjllb" type="primary" size="mini" plain>保存</el-button>
        </div>
      </el-tab-pane>
      <!-- 利润表季报 end -->
    </el-tabs>
    <!-- content end -->
  </div>
</template>

<script>
import { yearInfo, yearEdit } from '@/api/year'
// import waves from "@/directive/waves";
export default {
  name: "yearFinance",
  // directives: { waves },
  props: {
    tableYearName: {
      default:'',
      type:String
    },
    comId:{
      default:0,
      type:Number
    },
  },
  data() {
    return {
      fullscreenLoading:false,
      list:[{"id":156,"kjMainId":14,"type":1,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":157,"kjMainId":14,"type":2,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":158,"kjMainId":14,"type":3,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":159,"kjMainId":14,"type":4,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":160,"kjMainId":14,"type":5,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":161,"kjMainId":14,"type":6,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":162,"kjMainId":14,"type":7,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":163,"kjMainId":14,"type":8,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":164,"kjMainId":14,"type":9,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":165,"kjMainId":14,"type":1,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":166,"kjMainId":14,"type":11,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":167,"kjMainId":14,"type":12,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":168,"kjMainId":14,"type":13,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":169,"kjMainId":14,"type":14,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":170,"kjMainId":14,"type":15,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":171,"kjMainId":14,"type":16,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":172,"kjMainId":14,"type":17,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":173,"kjMainId":14,"type":18,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":174,"kjMainId":14,"type":19,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":175,"kjMainId":14,"type":20,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":176,"kjMainId":14,"type":21,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":177,"kjMainId":14,"type":22,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":178,"kjMainId":14,"type":23,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":179,"kjMainId":14,"type":24,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":180,"kjMainId":14,"type":25,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":181,"kjMainId":14,"type":26,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":182,"kjMainId":14,"type":27,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":183,"kjMainId":14,"type":28,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":184,"kjMainId":14,"type":29,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":185,"kjMainId":14,"type":3,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''},{"id":186,"kjMainId":14,"type":31,"zcxmmc":"","qmyeZc":'',"ncyeZc":'',"qyxmmc":"","qmyeQy":'',"ncyeQy":''}],
      attachArr: [{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}],
      xjllbList: [{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}],
      activeName: '1',
      
    };
  },
  created() {
    // 获取表格高度
    this.contentStyleObj=this.$getHeight(400)
    window.addEventListener('resize', this.getHeight);
    this.getParams()
  },
  // 销毁监听事件，从这个页面离开就销毁监听事件
  destroyed(){
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    // 获取基本信息表
    getParams() {
      if(this.tableYearName){
        yearInfo({comId:this.comId,period:'2022',tableName:this.tableYearName}).then(res => {
          if(res.data.data){
            this.list = res.data.data;
          }
        });
      }else{
        yearInfo({tableName:'year_zcfz'}).then(res => {
          this.list = res.data.data;
        });
      }
    },
   handleClick(tab, event) {
      if(tab.props.label == '资产负债表'){
        // 基本信息
        if(this.tableYearName){
          yearInfo({comId:this.comId,period:'2022',tableName:'year_zcfz'}).then(res => {
            if(res.data.data){
              this.list = res.data.data;
            }
          });
        }else{
          yearInfo({tableName:'year_zcfz'}).then(res => {
            this.list = res.data.data;
          });
        }
        this.name = tab.props.label
        console.log(this.name);
      }else if(tab.props.label  == '利润表(年报)') {
         // 基本信息
        if(this.tableYearName){
          yearInfo({comId:this.comId,period:'2022',tableName:'year_lrb'}).then(res => {
            if(res.data.data){
              this.attachArr = res.data.data;
            }
          });
        }else{
          yearInfo({tableName:'year_lrb'}).then(res => {
            this.attachArr = res.data.data;
          });
        }
        this.name = tab.props.label
      }else if(tab.props.label == '现金流量表') {
        if(this.tableYearName){
          yearInfo({comId:this.comId,period:'2022',tableName: 'year_xjllb'}).then(res => {
            if(res.data.data.length == 22){
              this.xjllbList = res.data.data;
            }
            this.type = res.data.data.type
          })
        }else{
          yearInfo({tableName: 'year_xjllb'}).then(res => {
            if(res.data.data.length == 22){
              this.xjllbList = res.data.data;
            }
            this.type = res.data.data.type
          })
        }
        this.name = tab.props.label
      }
    },
    // 资产负债表保存
    saveZcfz(){
      this.fullscreenLoading = true
      this.list.map(v=>{
        v.ncyeQy = Number(v.ncyeQy)
        v.ncyeZc = Number(v.ncyeZc)
        v.qmyeQy = Number(v.qmyeQy)
        v.qmyeZc = Number(v.qmyeZc)
      })
      yearEdit({comId:this.comId,period:'2022',tableName:'year_zcfz',items:this.list}).then(res => {
        if(res.data.msg == 'success'){
          this.$message({
            message: "保存成功",
            type: "success"
          });
        }
        this.fullscreenLoading = false
        yearInfo({comId:this.comId,period:'2022',tableName:'year_zcfz'}).then(res => {
          if(res.data.data){
              this.list = res.data.data;
            }
        });
      });
    },
    // 利润表保存
    saveLrb(){
      this.fullscreenLoading = true
      this.attachArr.map(v=>{
        v.lastYearTotal = Number(v.lastYearTotal)
        v.yearTotal = Number(v.yearTotal)
      })
      yearEdit({comId:this.comId,period:'2022',tableName:'year_lrb',items:this.attachArr}).then(res => {
        if(res.data.msg == 'success'){
          this.$message({
            message: "保存成功",
            type: "success"
          });
        }
        this.fullscreenLoading = false
        yearInfo({comId:this.comId,period:'2022',tableName:'year_lrb'}).then(res => {
          if(res.data.data){
            this.attachArr = res.data.data;
          }
        });
      });
    },
    saveXjllb(){
      this.fullscreenLoading = true
      this.xjllbList.map(v=>{
        v.lastYearTotal = Number(v.lastYearTotal)
        v.yearTotal = Number(v.yearTotal)
      })
      yearEdit({comId:this.comId,period:'2022',tableName:'year_xjllb',items:this.xjllbList}).then(res => {
        if(res.data.msg == 'success'){
          this.$message({
            message: "保存成功",
            type: "success"
          });
        }
        this.fullscreenLoading = false
        yearInfo({comId:this.comId,period:'2022',tableName:'year_xjllb'}).then(res => {
          if(res.data.data){
            this.xjllbList = res.data.data;
          }
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.top_btns {
  .left_box{
    float: left;
    width: 76%;
  }
  .right_box {
    float: right;
    width: 20%;
    text-align: right;
  }
}
.big_box4{
  width: 98%;
  // padding: 40px;
  background: #fff;
  // box-shadow: 0 2px 10px #ddd;
  margin: 0 auto;
  box-sizing: border-box;
}
.center{
  text-align: center;
}
.left{
  text-align: left;
}
.right{
  text-align: right;
}
.weight{
  font-weight: 700;
}
.row_box{
  border-bottom: 1px solid #eee;
}
.top_title3{
  width: 100%;
  margin: 0 auto;
  h5{
    font-size: 20px;
    color: #333;
    font-weight: 700;
    text-align: center;
  }
  .bottom_font{
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;
    // position: relative;
    h6{
      float: left;
      width: 33.33%;
      font-size: 12px;
      color: #333;
      font-weight: normal;
      // position: absolute;
      // bottom: 0;
    }
    h6:nth-child(1){
      padding-top: 10px;
    }
    h6:nth-child(2){
      padding-top: 10px;
    }
  }
}
.left_k{
  text-indent: 2em;
}
.left_b{
  text-indent: 4em;
}
.left_x{
  text-indent:5em;
}
.left_d{
  text-indent:8em;
}
.save_box{
  margin: 0 auto;
  margin-top: 20px;
  text-align: center;
}
.content{
  // width: 2000px;
  width: 100%;
  margin: 0 auto;
  border:1px solid #c2c2c2;
  border-bottom: none;
  border-right: none;
  margin-top: 10px;
 
  span{
    line-height: 28px;
    font-size: 13px;
  }
  tr{
    padding: 0;
    margin: 0;
  }
  td{
    border-right:1px solid #c2c2c2;
    border-bottom:1px solid #c2c2c2;
    line-height: 28px;
    padding:0 6px;
    color: #333;
    font-size: 13px;
  }
  input{
    width: 100%;
    line-height: 28px;
    padding: 0 6px;
    font-size: 13px;
    padding-right:20px;
  }
}
</style>